import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from "reactstrap";
import AccordionContainer from "../../common/accordion-container";
import { SaveIcon } from "../../common/icons";
import LabelCol from "../../common/label-col";
import { IWsClient, IWsClientInput } from "../../../types/ws-admin";
import { useEffect, useState } from "react";
import { GET_WS_CLIENTS, UPDATE_WS_CLIENT } from "../../../graphql/ws-admin-gql";
import { useMutation } from "@apollo/client";
import SpinnerOverlay from "../../common/spinner/spinner";
import { notifySuccess } from "../../../services/notification";
import WsClientForm from "./ws-client-form";
import { getFormDataObject } from "../../../utils/commons";
import { encryptRSA } from "../../../utils/encrypt";
import AutoFocusDiv from "../../common/auto-focus-div";

type WsClientUpdateProps = {
    client: IWsClient
}
const WsClientUpdate = (props: WsClientUpdateProps) => {
    const { client } = props;

    const [active, setActive] = useState<boolean>()

    const [updateWsClient, { loading: loadingSave }] = useMutation(UPDATE_WS_CLIENT)

    useEffect(() => {
        setActive(client.active)
    }, [client])

    const handleSubmit = (event: any) => {
        event.preventDefault()

        const input = getFormDataObject<IWsClientInput>(event.currentTarget)

        const updatedInput = {
            ...input,
            password: input.password ? encryptRSA(input.password) : '',
            active: active
        };

        updateWsClient({
            variables: {
                clientId: client.clientId,
                input: updatedInput
            },
            refetchQueries: [{
                query: GET_WS_CLIENTS
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                data && notifySuccess()
            }
        })
    }

    const onExpiryChange = (event: any) => {
        setActive(!event.target.checked)
    }

    return (
        <Card>
            <CardBody>
                <CardTitle>
                    <AutoFocusDiv trigger={client}>
                        Client: {client.clientName}
                    </AutoFocusDiv>
                </CardTitle>

                <AccordionContainer title="Client Information">
                    <WsClientForm id="update_client_form" onSubmit={handleSubmit} data={client} />

                    <Row className="row">
                        <Col className="col-auto">
                            <Button form="update_client_form" type="submit" color="primary">
                                <SaveIcon /> Save
                            </Button>
                        </Col>
                        <LabelCol md={6}>
                            <FormGroup check>
                                <Input id="clientExpired" name="clientExpired" type="checkbox" checked={!active} onChange={onExpiryChange} />
                                <Label for="clientExpired">Expired</Label>
                            </FormGroup>
                        </LabelCol>
                    </Row>
                </AccordionContainer>

                {loadingSave && <SpinnerOverlay />}
            </CardBody>
        </Card>
    )
}

export default WsClientUpdate
